import DonutSmallOutlinedIcon from "@mui/icons-material/DonutSmallOutlined"
import { Grid, Typography } from "@mui/material"

import React, { useContext } from "react"
import { customPalette } from "../../../../../../../theme"
import { AddressDisplayer } from "../../../../../../components/AddressDisplayer"
import { InfoItem } from "../../../../../../components/card/components/InfoItem"
import { IconFileAnalytics } from "../../../../../../components/custom-icons/icon-file-analytics"
import { ProjectContext } from "../../../../../../core/context/project/ProjectContext"
import { ProjectCountersContext } from "../../../../../../core/context/project/ProjectCountersContext"
import { formatToFrench } from "../../../../../../core/services/date-service"
import { ModuleProjectBadge } from "./ModuleProjectBadge"

export function ProjectInfoDisplayer(): React.JSX.Element {
  const { project } = useContext(ProjectContext)

  const { rseeDocumentNumber, variantNumber } = useContext(ProjectCountersContext)

  return (
    <Grid container borderRadius={3} alignContent="center" gap={1}>
      <Grid item xs={12}>
        <Typography variant="h5"> {project?.name}</Typography>
      </Grid>
      <Grid item xs={12}>
        <AddressDisplayer address={project?.address} />
      </Grid>
      <Grid item xs={12} columnGap={2} display="flex">
        <ModuleProjectBadge
          icon={<DonutSmallOutlinedIcon sx={{ color: customPalette.lightGreen10 }} />}
          backgroundColor={customPalette.lightGreen9}
          color={customPalette.lightGreen10}
          value={variantNumber?.toString()}
        />

        {/* Uncomment when beem master */}
        {/*<ModuleProjectBadge*/}
        {/*  icon={<IconBeemMaster sx={{ color: customPalette.redWrongValue }} />}*/}
        {/*  backgroundColor={customPalette.lightRed}*/}
        {/*  color={customPalette.redWrongValue}*/}
        {/*  value={countBeemMasterProject?.toString()}*/}
        {/*/>*/}

        <ModuleProjectBadge
          icon={<IconFileAnalytics sx={{ color: customPalette.lightBlue2 }} />}
          backgroundColor={customPalette.lightGray7}
          color={customPalette.lightBlue2}
          value={rseeDocumentNumber?.toString()}
        />
      </Grid>
      <Grid item xs={12} container spacing={1} pt={1}>
        <Grid item xs={4}>
          <InfoItem label="Date de dépôt de permis" value={formatToFrench(project?.licenceDate) ?? ""} />
        </Grid>
        {/* Uncomment when we have phase on the project */}
        {/*<Grid item xs={4}>*/}
        {/*  <InfoItem label="Phase actuelle" value="" />*/}
        {/*</Grid>*/}
        <Grid item xs={4}>
          <InfoItem label="N° d'affaire" value={project?.businessCode ?? ""} />
        </Grid>
      </Grid>
    </Grid>
  )
}
